import {texture} from "p3";
import common from "../common";
import GameScene from "../scenes/GameScene";

export default class VirtualJoystick extends PIXI.Container {
    constructor() {
        super();

        this._joystickAnchor = null;
        this._joystickAnchorAlpha = 0.8;
        this._joystickAnchorTween = null;

        this._joystick = null;
        this._joystickAlpha = 0.8;
        this._joystickTween = null;

        this.init();
    }

    init() {
        this._joystickAnchor = new PIXI.Sprite(texture("joystick_area"));
        this._joystickAnchor.anchor.set(0.5);
        this._joystickAnchor.visible = false;
        this.addChild(this._joystickAnchor);

        this._joystick = new PIXI.Sprite(texture("joystick"));
        this._joystick.anchor.set(0.5);
        this._joystick.visible = false;
        this.addChild(this._joystick);
    }

    destroy() {
        this.stopAnimation();

        super.destroy({ children: true });
    }

    update() {
        let touch = GameScene.active.joystickTouch;

        if (touch) {
            let pos = this.toLocal(touch.pos, common.stage);
            this._joystick.position.set(pos.x, pos.y);
        }
    }

    /**
     * @param {PIXI.Point} position
     */
    showJoystick(position) {
        this._joystick.alpha = 0;
        this._joystickAnchor.position = position;
        this._joystickAnchor.alpha = 0;

        this.stopAnimation();

        GameScene.active.addTween(this._joystickTween = gsap.to(this._joystick, 0.2, {
            alpha: this._joystickAlpha,
            ease: Power2.easeInOut,
            onStart: () => this._joystick.visible = true
        }));
        GameScene.active.addTween(this._joystickAnchorTween = gsap.to(this._joystickAnchor, 0.2, {
            alpha: this._joystickAnchorAlpha,
            ease: Power2.easeInOut,
            onStart: () => this._joystickAnchor.visible = true
        }));
    }

    hideJoystick() {
        this.stopAnimation();

        GameScene.active.addTween(this._joystickTween = gsap.to(this._joystick, 0.2, {
            alpha: 0,
            ease: Power2.easeInOut,
            onStart: () => this._joystick.visible = true
        }));
        GameScene.active.addTween(this._joystickAnchorTween = gsap.to(this._joystickAnchor, 0.2, {
            alpha: 0,
            ease: Power2.easeInOut,
            onStart: () => this._joystickAnchor.visible = true
        }));
    }

    stopAnimation() {
        if (this._joystickTween !== null) {
            this._joystickTween.kill();
            this._joystickTween = null;
        }
        if (this._joystickAnchorTween !== null) {
            this._joystickAnchorTween.kill();
            this._joystickAnchorTween = null;
        }
    }
}